export default class globalNavi{
    constructor(pageID,param){

        /* 必要なDOM */
        this.header = document.getElementById('l-header');
        if(document.getElementById('p-kv') != null){
            this.kv = document.getElementById('p-kv');
        }
        this.btn = document.getElementById('l-header-btn');
        this.naviContent = document.getElementById('l-header__navi');
        this.showList = document.querySelectorAll('#l-header__navi__list li');
        this.link = this.header.querySelector('.c-btn');
        this.sns = document.getElementById('l-header__navi__sns');
        this.bg = document.getElementById('l-header-bg');

        this.search = document.getElementById('c-search');

        this.h = document.getElementById('l-root').clientHeight;

        /* 設定 */
        this.conf = {
        }

        /* ステータス */
        this.status = {
            now : "close",
            device : ( window.innerWidth>param.breakpoint )?"pc":"sp",
            type : "top",
            show : false,
        }

        this.param = param;

        this.init(pageID);
        if(window.innerWidth>param.breakpoint){
            this.set("pc");
        }else{
            this.set("sp");
        }

    }
    init(pageID) {

        this.update();

        //click
        this.btn.onclick = () => {
            if(this.status.now === 'close'){
                this.status.now = 'open';
                this.btn.classList.add('is-close');
                this.header.classList.add('is-open');
            }else{
                this.status.now = 'close';
                this.btn.classList.remove('is-close');
                this.header.classList.remove('is-open');
            }
            this.navi();
        };

        this.bg.onclick = () => {
            this.status.now = 'close';
            this.btn.classList.remove('is-close');
            this.header.classList.remove('is-open');
            this.navi();
        };

        TweenMax.fromTo(this.header, 0.6 , {
            opacity: 0,
            y:-15,
        },{
            delay:3.8,
            opacity: 1,
            y:0,
            ease: Back.easeOut.config(1)
        });


    }

    snsShow(){

        TweenMax.set(this.sns,{
            opacity : 1,
            onComplete:()=>{
                TweenMax.fromTo(this.sns.children, 0.6 , {
                    x : 200,
                },{
                    x : 0,
                    ease : Back.easeOut.config(1)
                });
            }
        });

    }

    navi(){ //グローバルナビの表示非表示

        switch(this.status.now) {
            case "open":
                TweenMax.set([this.naviContent,this.showList,this.bg],{
                    display: 'none',
                    opacity : 0,
                });
                TweenMax.set([this.link,this.sns],{
                    opacity : 0,
                });
                TweenMax.set([this.naviContent,this.showList],{
                    x : 80
                });
                TweenMax.to([this.naviContent,this.bg],0.55, {
                    display : 'block',
                    opacity : 1,
                    x:0,
                    ease: Sine.easeOut,
                    onStart:()=>{
                        TweenMax.staggerTo(this.showList ,0.75, {
                            delay:0.1,
                            opacity : 1,
                            display : 'block',
                            x : 0,
                            ease: Back.easeOut.config(1)
                        },0.025);
                        TweenMax.to([this.link,this.sns] ,0.25, {
                            delay:0.45,
                            opacity : 1,
                            ease: Sine.easeOut
                        });
                    }
                });
                break;
            case "close":
                TweenMax.to(this.showList ,0.55, {
                    opacity : 0,
                    display : 'block',
                    x : 100,
                    ease: Sine.easeIn
                });
                TweenMax.to([this.link,this.sns] ,0.15, {
                    opacity : 0,
                    ease: Sine.easeIn
                });
                TweenMax.to(this.naviContent,0.55, {
                    delay:0.1,
                    x : 100,
                    display : 'none',
                    opacity : 0,
                    ease: Sine.easeIn
                });
                TweenMax.to(this.bg,0.5, {
                    delay:0.1,
                    display : 'none',
                    opacity : 0,
                    ease: Sine.easeIn
                });
                break;
        }
    }

    update(_y){ // 白黒を切替える処理

        // fixed
        if(_y > this.kv.clientHeight/2){
            if(_y >= this.h){
                this.status.show = false;
                TweenMax.to(this.search,0.5,{
                    x:30,
                    scale:0.8,
                    opacity : 0,
                    display : 'none',
                    ease: Sine.easeOut
                });
            }else{
                if(this.status.show === true) return;
                this.status.show = true;
                TweenMax.to(this.search,0.1,{
                    x:0,
                    scale:1,
                    opacity : 1,
                    display : 'block',
                    ease: Sine.easeIn
                });
            }
            this.header.classList.add('type-color');
            if(this.status.type === 'fixed') return;
            this.status.type = 'fixed';
        }else{
            this.status.show = false;
            this.status.type = 'top';
            this.header.classList.remove('type-color');
            TweenMax.to(this.search,0.5,{
                x:30,
                scale:0.8,
                opacity : 0,
                display : 'none',
                ease: Sine.easeOut
            });
        }

    }

    set(type){ // pcサイズ、spサイズリサイズによる初期化

        this.status.now = 'close';

        let _length = this.showList.length;
        for(var i = 0 ; i < _length ; i++){
            this.showList[i].removeAttribute('style');
        }

        switch(type) {
            case "pc":
                this.header.classList.remove('is-open');
                break;
            case "sp":
                break;
        }

    }

    resize(_w,_h){

        this.h = parseInt(document.body.style.height) - parseInt(_h);

        if(_w>this.param.breakpoint){
            if(this.status.device==="sp") this.set("pc");
            this.status.device = "pc";
        }else{
            if(this.status.device==="pc") this.set("sp");
            this.status.device = "sp";
        }
    }
}